import { EtapaOrdemProducao } from "app/types/OrdemProducao";
import globalMU from "globalMU";
import React from "react";

const estiloTabela = require('../../../estilos/tabelas.module.scss').default

type ConsultarEtapaOrdemProducaoProps = {
    dadosEtapaOrdemProducao: EtapaOrdemProducao[]
}

export const ConsultarEtapaOrdemProducao = (props: ConsultarEtapaOrdemProducaoProps) => {

    const headerTabelaEtapasProducao = () => {
        const mapHeader = ["Ordem", "Etapa de Produção", "Execução", "Operador"]

        return mapHeader.map((nome) => <th key={nome} className={`_table-cell`}>{nome}</th>)
    }

    const bodyTabelaEtapasProducao = (dado: EtapaOrdemProducao) => {
        const mapHeader = [dado.Ordem, dado.NomeEtapa, globalMU.formatDate(dado.Data), dado.Funcionario]

        return mapHeader.map((nome, indice) => <td key={indice} className="_table-cell">{nome}</td>)
    }

    return (
        <>
            <div className="_flex">
                <table className={`_table _w-full _border-collapse ${estiloTabela.tabela}`}>
                    <thead className="_table-header-group">
                        <tr className="_table-row">
                            {headerTabelaEtapasProducao()}
                        </tr>
                    </thead>

                    <tbody className="_table-row-group">
                        {props.dadosEtapaOrdemProducao?.map((dado) => (
                            <tr key={dado.Ordem} className="_table-row">
                                {bodyTabelaEtapasProducao(dado)}
                            </tr>
                        ))}
                    </tbody>

                </table>
            </div>
        </>
    )
}